import DiagramWithToggleKey from "../shared/DiagramWithToggleKey";
import NutritionVitaminACombined from "./index";

const NutritionVitaminAWithToggleKey = props => (
  <DiagramWithToggleKey
    CombinedDiagram={NutritionVitaminACombined}
    keyControlsId="nutrition-vitamin-a-key"
    {...props}
  />
);

export default NutritionVitaminAWithToggleKey;
